export interface DtoEntity<A> {
    id: string;
    value: A;
}

export const mapDto =
    <A, B>(fab: (a: A) => B) =>
    (dtoEntity: DtoEntity<A>): DtoEntity<B> => {
        return {
            ...dtoEntity,
            value: fab(dtoEntity.value),
        } as DtoEntity<B>;
    };

export const ofDto = <A>(id: string, value: A): DtoEntity<A> => ({ id, value });
